import React from "react";
import { useTranslation } from "react-i18next";
import { RemitProposalAction } from "us.collection.economy/components/Remit/Constants";
import { ProfileOutlined } from "us.icons";
import { IItemMenu } from "./interface";

/**
 * @description - Remit details table
 * @link Design Document - https://unicorn-solutions.atlassian.net/wiki/spaces/USU/pages/2858189310/Remit+Proposal+UI+Design+and+Implementations
 * @author Lashini Ayesha <lashinia@unicorn-solutions.com>
 * @since 14/06/2024
 */

const ItemMenu: React.FC<IItemMenu> = ({
  actions = [RemitProposalAction.VIEW_REMIT_DETAILS],
  onCallAction,
}) => {
  const { t } = useTranslation();

  return (
    <div className="table-more-content">
      {actions.includes(RemitProposalAction.VIEW_REMIT_DETAILS) && (
        <div
          data-testid="btn-remit-details"
          className="d-flex align-items-center  flex-row more-item"
          onClick={() => onCallAction(RemitProposalAction.VIEW_REMIT_DETAILS)}
        >
          <div className="p-1" style={{ fontSize: "1.2rem" }}>
            <ProfileOutlined />
          </div>
          <div className="p-1">
            {t("US.COLLECTION.ECONOMY:REMIT.REMIT_DETAILS")}
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemMenu;
